// Acceso a localStorage que nunca rompe la app: en navegación privada, con el almacenamiento
// lleno o bloqueado, las lecturas devuelven el valor por defecto y las escrituras se ignoran.

export const readJson = <T>(key: string, fallback: T, storage: Storage | undefined = globalThis.localStorage): T => {
	try {
		const raw = storage?.getItem(key)
		return raw === null || raw === undefined ? fallback : (JSON.parse(raw) as T)
	} catch {
		return fallback
	}
}

export const writeJson = (
	key: string,
	value: unknown,
	storage: Storage | undefined = globalThis.localStorage
): boolean => {
	try {
		storage?.setItem(key, JSON.stringify(value))
		return storage !== undefined
	} catch {
		return false
	}
}
